<template>
	<div class="data-table data-table-header" >
		<div class="data-report">
			<span>Dati Richiedente</span>
			<p>{{ site.clientName }}</p>
		</div>													

		
		<div class="data-report">
			<span>matricola motore</span>
			<p>{{ engine.registrationNumber }}</p>
		</div>


						
		<div class="data-report">
			<span>Dati Società</span>
			<p>{{ site.businessData }}</p>
		</div>				
		
		<div class="data-report">
			<span>Modello motore</span>
			<p>{{ engine.model }}</p>
		</div>

		<div class="data-report">
			<span>C/o Soc./Cantiere</span>
			<p>{{ site.name }}</p>
		</div>	

		
		<div class="data-report">
			<span>ore totali</span>
			<p>{{ revision.engineHour }}</p>
		</div>								


		<div class="data-report">
			<span>indirizzo</span>
			<p>{{ site.address }}</p>
		</div>								
				
		
		<div class="data-report">
			<span>ore di servizio</span>
			<p>{{ revision.serviceEngineHour }}</p>
		</div>								
		
		

		
							
		<div class="data-report">
			<span>Persona di riferimento</span>
			<p v-if="revision.referent">{{ revision.referent.contactName }} <span v-if="revision.referent.phone">	- {{ revision.referent.phone }}</span></p>
		</div>		
	

		<div class="data-report">
			<span>Tecnico/i intervenuto</span>
			<p>
				<span class="d-inline" :key="$index" v-for="(worker,$index) in revision.workers" v-if="worker">
					{{worker.name[0]}} {{worker.surname}} <span class="d-inline" v-if="$index != revision.workers.length -1">,</span> </span>
			</p>
		</div>

		<div class="data-report" v-if="revision.phase === 'final'">
			<span>{{ revision.referenceOrderLabel }}</span>
			<p>{{ revision.referenceOrder }}</p>
		</div>
		<div class="data-report" v-else />

		<div class="data-report">
			<span>Responsabile</span>
			<p>{{ revision.responsible }}</p>
		</div>		


						

	</div>
</template>
<style lang="scss">
</style>
<script>
	export default{
		name: 'print-revision-header',
		props: {
			revision: Object,
			site: Object,
			engine: Object,
		},
		methods:{
			calculateTotalOfWorkedDeatails(key){
				let sum = 0;
				this.revision.workedDetails.days.forEach(day => {
					sum = day[key] ? sum + parseFloat(day[key]) : sum;
				})
				const total = parseFloat(this.revision.workedDetails.detailsSingleAmount[key]) * sum;
				return isNaN(total) ? 0 : total;
			},
		}
	}
</script>